import React from "react";
import PropTypes from "prop-types";
import "../../styles/VerifyInformation.scss";
import TextInput from "../text-input/TextInput";
import TextArea from "../text-area/TextArea";
import VerifyInformationSchema from "../../schemas/VerifyInformationSchema";
import HelperText from "../helper-text/HelperText";
import formatPhoneNumber from "../Helper/HelperFunctions";

const VerifyInformation = (props) => {

    const { contractForm, contractDetailsData } = props;
    const { register, setValue, getValues } = contractForm;
    const { phoneNumber, emailAddress } = VerifyInformationSchema;
    const [, setAdminType] = React.useState(null);

    React.useEffect(() => {
        handleAdminType();
        bindFormData();
        // handleAdminType/bindFormData read props/localStorage once on mount.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleAdminType = () => {
        const data = JSON.parse(localStorage.getItem('tpa_data'));
        if (data?.admin_Type) {
            setAdminType(data?.admin_Type);
            return;
        }
        return;
    }

    const setPhoneNumber = (e) => {
        e.preventDefault();
        const phNumberValue = e.target.value;

        let cleaned = ('' + phNumberValue).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{1,3})(\d{0,3})(\d{0,4})(\d{0,4})$/);
        if (match) {
            cleaned = `(${match[1]}${match[2] ? ') ' : ''}${match[2]}${match[3] ? '-' : ''}${match[3]}${match[4] ? ' x' : ''}${match[4]}`;
        }
        setValue(e.target.name, cleaned, { shouldValidate: true });
        return;
    }

    const generateFullAddress = () => {
        const { customer } = contractDetailsData;
        const address = [];
        if (customer?.address1) {
            address.push(customer?.address1);
        }
        if (customer?.address2) {
            address.push(customer?.address2);
        }
        var add = "";
        if (customer?.city) {
            add = add + customer?.city + ',';
        }
        if (customer?.state) {
            add = add + ' ' + customer?.state + '';
        }
        if (customer?.zipCode) {
            //add = add.slice(0, -1);
            add = add + ' ' + formatZipCode(customer?.zipCode) + '';
        }
        if (add) {
            //add = add.slice(0, -1);
            address.push(add);
        }
        return address.join("\n");
    }

    const formatZipCode = (value) => {
        var formattedZipCode = "";
        if (value?.length === 6) {
            formattedZipCode = value.substr(0, 3) + ' ' + value.substr(2, 3);
            return formattedZipCode;
        }
        if (value?.length > 6) {
            formattedZipCode = value.substr(0, 5).replace('-', '') + '-' + value.substr(5, value.length).replace('-', '');
            return formattedZipCode;
        }
        return value;
    }

    const bindFormData = () => {
        const { customer } = contractDetailsData;
        if (customer) {
            setValue('contractHolderName', customer?.name);
            setValue('contractHolderAddress', generateFullAddress());
            setValue('sendText', customer?.send_text);
            if (!getValues('phoneNumber')) setValue('phoneNumber', formatPhoneNumber(customer?.phoneNumber));
            setValue('secondaryPhone', customer?.secondaryPhoneNumber);
            if (!getValues('emailAddress'))setValue('emailAddress', customer?.email);
            return;
        }
    }

    const handleSetValue = (e, key) => {
        e.preventDefault();
        setValue(key, e.target.value.trim().toUpperCase(), { shouldValidate: true })
    }

    return (
        <React.Fragment>
            <div className="info-heading">Verify Your Information</div>
            <div>
                <div className="mt-20">
                    <TextInput name="contractHolderName" fieldRegister={register('contractHolderName')} disabled={true} label="Contract Holder Name" {...props} />
                </div>
                <div className="mt-20">
                    <TextArea cols={44} rows={3} label="Address" name="contractHolderAddress" disabled={true} placeholder="Address" fieldRegister={register('contractHolderAddress')} />
                    <HelperText text="If your address has changed, continue to create your claim then enter a note with your new address and we will update your information." isShownHelperIcon={false} />
                </div>
                <div className="mt-20">
                    <TextInput
                        label="Phone"
                        name="phoneNumber"
                        fieldRegister={register('phoneNumber', {
                            ...phoneNumber,
                            onChange: (e) => { setPhoneNumber(e) }
                        })}
                        errorMessage={contractForm.formState.errors?.phoneNumber?.message || null}
                        isRequired={true}
                        maxLength={14}
                        {...props}
                    />
                    <HelperText text="Make sure we have your correct contact number." isShownHelperIcon={false} />
                </div>
                {/*<div className="mt-5">*/}
                {/*    <GapCheckBox id="test" name="sendText" fieldRegister={register("sendText")} label="Send me texts about my claim" />*/}
                {/*</div>*/}
                <div className="mt-20">
                    <TextInput
                        label="Email"
                        name="emailAddress"
                        fieldRegister={register('emailAddress', {
                            ...emailAddress,
                            onChange: (e) => { handleSetValue(e, 'emailAddress') }
                        })}
                        errorMessage={contractForm.formState.errors?.emailAddress?.message || null}
                        isRequired={true}
                        {...props}
                    />
                    <HelperText text="Make sure we have your correct email address." isShownHelperIcon={false} />
                </div>
            </div>
        </React.Fragment>
    )
};

VerifyInformation.propTypes = {
    contractForm: PropTypes.object,
    contractDetailsData: PropTypes.object
}

export default VerifyInformation;